export const GRADE_11_PAGE_TITLE = 'تانية ثانوي Programming & AI';

export const GRADE_11_HERO_IMAGES = [
    '/img/ghonaim-transparent-standing-side.png',
    '/img/ghonaim-transparent-tablet.png',
];

export const grade11Hero = {
    badge: 'تانية ثانوي 2026–2027',
    title: 'تانية ثانوي محتاجة نظام… مش فيديوهات وخلاص',
    subtitle:
        'في تانية ثانوي، Programming & AI محتاجة فهم للمنهج، تطبيق عملي، وأسئلة كتير. مع البرمجة مع غنيم الطالب يمشي بخطة واضحة: يفهم، يطبق، يراجع، ويدخل الامتحان بثقة.',
    primaryCta: 'ابدأ كورس تانية ثانوي',
    secondaryCta: 'تواصل واتساب',
    chips: [
        'شرح المنهج',
        'تدريب عملي',
        'Coding Lab',
        'Community',
        'Live عند الحاجة',
        'Calendar طول السنة',
        '2,400+ سؤال في أول شابترين',
        'مراجعات وامتحانات',
    ],
};

export const grade11IntroVideo = {
    title: 'تعرّف على نظام تانية ثانوي',
    subtitle: 'شاهد الفيديو ده عشان تعرف إزاي بنغطي المنهج، والتدريب، والمراجعة طول السنة.',
    youtubeId: 'GHkdhbfqV6k',
    watchUrl: 'https://youtu.be/GHkdhbfqV6k',
};

export const grade11Why = {
    title: 'ليه تانية ثانوي محتاجة نظام؟',
    subtitle:
        'المادة مش فيديو شرح فقط. الطالب محتاج طريقة مذاكرة تجمع المنهج، التطبيق، الأسئلة، والمراجعة في مسار واحد.',
    cards: [
        {
            title: 'المنهج مهم',
            text: 'نبدأ بالمنهج والدرجة قبل أي شيء، لأن الهدف الأول إن الطالب يكون جاهز للامتحان.',
        },
        {
            title: 'العملي محتاج تدريب',
            text: 'الطالب لازم يكتب الكود بإيده، يجرب، ويعرف سبب الخطأ.',
        },
        {
            title: 'النظري محتاج فهم',
            text: 'المصطلحات والأفكار لازم تتفهم بأمثلة واضحة، مش تتحفظ وخلاص.',
        },
        {
            title: 'المراجعة طول السنة',
            text: 'مراجعات قصيرة ومنظمة تمنع التراكم قبل الامتحان.',
        },
    ],
    closing: 'المشكلة مش إن المادة صعبة… المشكلة إن الطالب يبدأها بدون نظام.',
};

export const grade11Coverage = {
    title: 'إحنا هنغطي إيه في تانية ثانوي؟',
    subtitle:
        'نغطي المنهج من غير تشتيت: شرح واضح، تطبيق عملي، أسئلة، ومراجعات في الوقت الصح.',
    items: [
        { title: 'شرح الجزء النظري', text: 'نشرح المفاهيم والمصطلحات بأمثلة من الحياة والمنهج.' },
        { title: 'شرح الجزء العملي', text: 'نشرح الكود خطوة بخطوة ونوضح طريقة التفكير.' },
        { title: 'حل أسئلة كتاب الوزارة', text: 'مش بس نجاوب، لكن نشرح ليه الإجابة صح وإزاي نفكر في السؤال.' },
        { title: 'تدريبات Sprix', text: 'نشتغل على أفكار وتدريبات Sprix المرتبطة بالمنهج.' },
        { title: 'Coding Lab', text: 'تدريب عملي على كتابة الكود وتصحيح الأخطاء.' },
        { title: 'واجبات وتدريبات', text: 'تدريب مستمر بعد الدروس عشان الفهم يثبت.' },
        { title: 'مراجعات Chapters', text: 'مراجعات منظمة بعد كل جزء مهم في المنهج.' },
        { title: 'امتحانات تدريبية', text: 'نماذج قصيرة تساعد الطالب يعرف مستواه.' },
    ],
};

export const grade11Journey = {
    title: 'رحلة الطالب معانا خطوة بخطوة',
    subtitle:
        'المسار بسيط: نفهم الدرس، نطبقه، نحل عليه، ونراجعه قبل ما يتراكم.',
    steps: [
        {
            title: 'نراجع الأساس ونبدأ من الصح',
            text: 'نثبت أهم الأساسيات قبل الدخول في تفاصيل المنهج.',
        },
        {
            title: 'نشرح الدرس ببساطة',
            text: 'كل فكرة تتشرح بأمثلة مباشرة من المنهج.',
        },
        {
            title: 'نطبّق عمليًا',
            text: 'الطالب يكتب الكود ويشوف النتيجة بنفسه.',
        },
        {
            title: 'نحل أسئلة',
            text: 'نشرح طريقة التفكير قبل الإجابة.',
        },
        {
            title: 'نراجع باستمرار',
            text: 'مراجعات أسبوعية وتراكمية لتثبيت المهم.',
        },
        {
            title: 'نستعد للامتحان',
            text: 'نماذج ومراجعات نهائية قبل الامتحان.',
        },
    ],
    closing: 'الطالب اللي يتفرج بس هينسى… الطالب اللي يكتب ويجرب هو اللي هيفهم.',
};

export const grade11Proof = {
    title: 'في أول شابترين بس… التدريب مش فيديو وخلاص',
    subtitle:
        'لحد نهاية Chapter 2، الطالب بيتدرب معانا على أكتر من 2,400 سؤال وفكرة مختلفة — من الشرح والواجبات والـQuizzes لأسئلة الوزارة والتقييمات والمقالي.',
    hero: {
        value: '2,400+',
        label: 'سؤال وتدريب',
        context: 'خلال أول شابترين فقط',
    },
    stats: [
        {
            value: '9',
            label: 'محاضرات حتى الآن',
            text: '7 دروس أساسية + مراجعتين شاملتين',
        },
        {
            value: '290+',
            label: 'لكل درس أساسي',
            text: 'شرح، Homework، Hub، Quiz، وأسئلة الوزارة',
        },
        {
            value: 'مش MCQ بس',
            label: 'تدريب متنوع',
            text: 'أمثلة، تطبيق، مقالي، وBaccalaureate-style',
        },
    ],
    note: 'الرقم من نظام التدريب الحالي حتى نهاية Chapter 2، قبل الامتحانات الشاملة والمسابقات والتحديات الإضافية.',
};

export const grade11Tools = {
    title: 'أدوات ودعم داخل النظام',
    subtitle: 'كل أداة ليها دور واضح: تدريب، سؤال، متابعة، أو مراجعة.',
    cards: [
        { title: 'Coding Lab', text: 'تطبيق عملي بدل المشاهدة فقط.' },
        { title: 'الكتاب التفاعلي', text: 'تنظيم للمذاكرة والمراجعة وفهم الأفكار.' },
        { title: 'Community', text: 'مكان للأسئلة ومتابعة النقاط غير الواضحة.' },
        { title: 'Live عند الحاجة', text: 'لايفات في الأوقات المهمة لحل الأسئلة والمراجعات.' },
        { title: 'امتحانات وتدريبات', text: 'اختبارات قصيرة ونماذج تساعد الطالب يعرف مستواه.' },
        { title: 'Calendar', text: 'خطة أسبوعية واضحة ومختصرة.' },
    ],
};

export const grade11Calendar = {
    title: 'Calendar ومراجعات طول السنة',
    subtitle:
        'بدل المذاكرة العشوائية، الطالب يعرف المطلوب منه كل أسبوع: درس، واجب، مراجعة، أو امتحان تدريبي.',
    bullets: [
        'مواعيد الدروس',
        'مواعيد الواجبات',
        'مراجعات على كل Chapter',
        'مراجعات تراكمية',
        'امتحانات تدريبية',
        'استعداد قبل الامتحان',
    ],
    highlight: 'مش هتذاكر بعشوائية… هتمشي بخطة.',
};

export const grade11Parents = {
    title: 'رسالة لولي الأمر',
    text:
        'احنا فاهمين قلق ولي الأمر: هل الطالب هيفهم؟ هل الكورس للمنهج فعلًا؟ وهل البرمجة صعبة؟ علشان كده البرنامج مركز على المنهج والدرجة، ومعاه تدريب ومراجعة ودعم عند الحاجة.',
    points: [
        'المنهج والدرجة هم الأولوية.',
        'التدريب العملي جزء أساسي.',
        'فيه مراجعات طول السنة.',
        'فيه Community ودعم.',
        'فيه Calendar يمنع التراكم.',
        'أي محتوى إضافي لا يشتت الطالب عن المنهج.',
    ],
    highlight: 'الدرجة مهمة… والفهم هو الطريق ليها.',
};

export const grade11Faq = {
    title: 'أسئلة شائعة عن تانية ثانوي',
    items: [
        {
            q: 'هل البرنامج مخصص لطلاب المدارس الإنجليزي ولا العربي؟',
            a: 'البرنامج معمول أساسًا لطلاب المدارس الإنجليزي لأن مادة Programming & AI عندهم بتحتاج شرح للمصطلحات والكود بالإنجليزي. وفي نفس الوقت الطالب العربي يقدر يستفيد، لأننا بنشرح بالعربي عند الحاجة عشان الفكرة توصل بوضوح.',
        },
        {
            q: 'هل الشرح كله إنجليزي؟',
            a: 'المصطلحات والكود بيظهروا بالإنجليزي زي المنهج، لكن الشرح والتوضيح بيكون بالعربي لما الطالب يحتاج ده. الهدف إن الطالب يفهم المعنى مش يحفظ ترجمة.',
        },
        {
            q: 'هل برنامج تانية ثانوي بيغطي المنهج كامل؟',
            a: 'آه، نغطي النظري والعملي وأسئلة كتاب الوزارة وتدريبات Sprix والمراجعات الأساسية قبل الامتحان.',
        },
        {
            q: 'هل فيه جزء نظري وجزء عملي؟',
            a: 'آه. النظري نشرحه بالفهم والأمثلة، والعملي نشتغل عليه بالكود والتجربة والتصحيح.',
        },
        {
            q: 'هل هتحلوا أسئلة كتاب الوزارة وتدريبات Sprix؟',
            a: 'آه، الاتنين جزء مهم من النظام. بنحل ونوضح طريقة التفكير عشان الطالب يعرف يتعامل مع السؤال بنفسه.',
        },
        {
            q: 'هل التدريب في الكورس أسئلة كتير فعلًا؟',
            a: 'آه. لحد نهاية Chapter 2 فقط، الطالب بيتدرب على أكتر من 2,400 سؤال وفكرة مختلفة: أمثلة أثناء الشرح، Homework، Ghonaim Hub، Quizzes، أسئلة كتاب الوزارة والتقييمات، ومقالي وBaccalaureate-style. الرقم ده قبل الامتحانات الشاملة والمسابقات.',
        },
        {
            q: 'يعني إيه Coding Lab؟',
            a: 'مساحة تدريب عملي يكتب فيها الطالب الكود، يجرب، يغلط، ويصلح. ده بيخلي الفهم أقوى من مجرد مشاهدة الشرح.',
        },
        {
            q: 'هل الطالب لازم يكون قوي في البرمجة قبل ما يبدأ؟',
            a: 'لا. هنراجع الأساسيات ونمشي خطوة بخطوة، لكن لازم الطالب يلتزم بالحل والتطبيق.',
        },
        {
            q: 'هل في Community أو Live؟',
            a: 'فيه Community للأسئلة والمتابعة. والـ Live بيكون عند الحاجة، خصوصًا قبل الامتحانات أو في الأجزاء اللي محتاجة توضيح مباشر.',
        },
        {
            q: 'هل في Calendar واضح؟',
            a: 'آه، الخطة بتوضح الطالب يدرس إيه، يحل إيه، ويراجع إيه كل أسبوع.',
        },
        {
            q: 'هل البرنامج يساعد الطالب يجيب 100/100؟',
            a: 'البرنامج معمول عشان يمشي الطالب في الطريق الصح لأعلى درجة: فهم، تطبيق، حل، ومراجعة. النتيجة تعتمد كمان على التزام الطالب.',
        },
        {
            q: 'هل في مراجعات قبل الامتحان؟',
            a: 'آه، فيه مراجعات على Chapters ومراجعات تراكمية ومراجعات نهائية قبل الامتحان.',
        },
        {
            q: 'إيه أهم حاجة الطالب يعملها عشان يستفيد؟',
            a: 'يحضر الشرح، يكتب الكود بإيده، يحل بعد كل درس، يراجع باستمرار، ويسأل أول ما يقف.',
        },
    ],
};

export const grade11FinalCta = {
    title: 'جاهز تبدأ تانية ثانوي بنظام واضح؟',
    subtitle:
        'ابدأ مع البرمجة مع غنيم وافهم Programming & AI بخطة منظمة تجمع الشرح، التطبيق، والمراجعة.',
    primaryCta: 'ابدأ الآن',
    secondaryCta: 'تواصل واتساب',
    hashtag: '#البرمجة_مع_غنيم',
};
